export enum PrintTemplateTypeEnum {
  WORD = 'WORD',
  JASPER = 'JASPER'
}
